
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/fetch",
      function () {
        return require("private-next-pages/examples/fetch.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/fetch"])
      });
    }
  